export default __webpack_public_path__ + "static/media/insta-icon.6c8af5fb.svg";